"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTrophy(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M17.106 22.468a.766.766 0 01.104 1.525l-.104.007H6.894a.766.766 0 01-.104-1.525l.104-.007h10.212zM19.15 0c.388 0 .708.288.759.662l.007.104-.001.255h3.32c.423 0 .766.343.766.766 0 2.723-1.91 5.441-4.279 5.826a7.92 7.92 0 01-6.955 6.138l-.001 5.653h2.299a.766.766 0 01.104 1.525l-.104.007H8.936a.766.766 0 01-.104-1.525l.104-.007h2.298v-5.653a7.92 7.92 0 01-6.957-6.138C1.91 7.227 0 4.51 0 1.787c0-.388.288-.708.662-.759l.104-.007h3.319V.766c0-.388.288-.708.662-.759L4.851 0H19.15zm-.766 1.532H5.617v4.34a6.383 6.383 0 1012.766 0v-4.34zm4.018 1.021h-2.487v3.429c1.122-.425 2.112-1.725 2.44-3.186l.047-.243zm-18.316 0H1.598l.008.044c.278 1.54 1.307 2.94 2.48 3.384v-.109l-.001-3.319z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgTrophy;
exports.default = _default;